import $ from 'jquery'
import InvalidIdpSessionError from './invalid-idp-session-error.js'
import AuthenticationFailedError from './authentication-failed-error.js'
import SamlResponse from './saml-response.js'
import IdpDestroySessionResponse from './idp-destroy-session-response.js'
import Promise from 'promise'
import utils from '../utils/utils.js'

var identityProvider = function(){}

function validateSamlRequest(samlRequest){
  if (samlRequest===undefined || samlRequest==='')
    throw new Error('no saml request given')

  if (samlRequest.auth===undefined)
    throw new Error('saml request has no auth property')

  if (samlRequest.auth.relayState===undefined)
    throw new Error('saml request has no relayState property')

  if (samlRequest.auth.samlRequest===undefined)
    throw new Error('saml request has no samlRequest property')
}

function validateSamlLogoutRequest(samlRequest){
  if (samlRequest===undefined || samlRequest==='')
    throw new Error('no saml request given')

  if (samlRequest.samlRequest===undefined)
    throw new Error('saml request has no samlRequest property')
}

function log(message){
  console.log('identity-provider: ' + message)
}

identityProvider.validateSession = function(samlRequest, localUrl = null){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      validateSamlRequest(samlRequest)

      let url = localUrl || samlRequest.auth.idp
      log('sending verification to ' + url)
      $.ajax({
        url: url,
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        dataType: 'json',
        xhrFields: {withCredentials: true},
        data: {
          RelayState: samlRequest.auth.relayState,
          SAMLRequest: samlRequest.auth.samlRequest
        }
      }).done((data, text, httpResponse)=> {
        console.log('returned status ' + httpResponse.status)
        log('valid saml session was found at idp ' + url)
        promiseRes(new SamlResponse(data.form, data.sp, data.samlResponse, samlRequest.auth.samlRequest, data.relayState))
      }).error((httpError)=> {
        console.log(`returned error ${httpError.status} from ${url}`)
        if (httpError.status === 202) {
          console.log(`${httpError.status} is unauthenticated on ${url}`)
          let location = utils.extractLocation(httpError)
          let message = 'no valid saml session found at idp ' + url + ', please provide credentials'
          log(message)
          promiseErr(new InvalidIdpSessionError(message, location, samlRequest.auth.samlRequest, samlRequest.auth.relayState))
        } else if (httpError.status === 0 && !localUrl) {
          localFallback(identityProvider.validateSession, arguments, url, promiseRes, promiseErr)
        }
         else {
          promiseErr(new Error(`verify session returned from ${url} server error ${httpError.status}`))
        }
      })
    } catch (err) {
      if (err instanceof Error)
        throw err
      promiseErr(new Error(`error requesting saml session at idp (${url}) due to ${err}`))
    }
  })
}

function localFallback(fn, args, url, promiseRes, promiseErr) {
  const localUrl = url.match(/\/api(?:.*)/).pop()
  console.log('trying local IDP server: ', localUrl)
  const argsArray = Array.prototype.slice.call(args)
  fn(...argsArray, localUrl)
    .then(promiseRes)
    .catch(promiseErr)
}

identityProvider.createSession = function(url, username, password, samlRequest, relayState, localUrl = null){
  url = localUrl || url
  console.log(`create session ${url}`)
  return new Promise((promiseRes, promiseErr)=> {
    try {
      if (url===undefined || url==='')
        throw new AuthenticationFailedError('no idp url given')

      if (username===undefined || username==='')
        throw new AuthenticationFailedError('no username given')

      if (password===undefined || password==='')
        throw new AuthenticationFailedError('no password given')

      if (samlRequest===undefined || samlRequest==='')
        throw new AuthenticationFailedError('no saml request given')

      if (relayState===undefined || relayState==='')
        throw new AuthenticationFailedError('no relay state given')

      console.log(`send request to ${url}`)

      $.ajax({
        url: url,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        xhrFields: {withCredentials: true},
        data: JSON.stringify({
          username: username,
          password: password,
          samlRequest: samlRequest,
          relayState: relayState
        })
      }).done((data, text, httpResponse)=> {
        console.log('returned status ' + httpResponse.status)
        if (httpResponse.status === 202) {
          console.log(httpResponse.status + ' is unauthenticated')
          let message = (data !== undefined) ? data.message : 'Unspecified error'
          let nextState = (data !== undefined) ? data.nextState : ''
          log(message)
          promiseErr(new AuthenticationFailedError(message, nextState))
        }
        else {
          console.log('session created for given credentials')
          promiseRes(new SamlResponse(data.form, data.sp, data.samlResponse, samlRequest, data.relayState))
        }
      }).error((httpError)=> {
        console.log(`create session returned error status '${httpError.status}' from ${url}`)

        if (httpError.status === 0 && !localUrl) {
          localFallback(identityProvider.createSession, arguments, url, promiseRes, promiseErr)
        }
        else {
          promiseErr(new Error('create session returned server error ' + httpError.status))
        }
      })
    } catch (err) {
      if ((err instanceof Error))
        throw err
      log('authentication attempt failed due to ' + err)
      promiseErr(new Error('attempt failed due to: ' + err))
    }
  })
}

identityProvider.destroySession = function(samlRequest, localUrl = null){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      validateSamlLogoutRequest(samlRequest)

      let url = localUrl || samlRequest.idp
      log('sending destroy session request to idp ' + url)
      $.ajax({
        url: url,
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        dataType: 'json',
        xhrFields: {withCredentials: true},
        data: {
          SAMLRequest: samlRequest.samlRequest
        }
      }).done((data, text, httpResponse)=> {
        log(url + 'session was destroyed at idp, returning saml response ')
        promiseRes(new IdpDestroySessionResponse(data))
      }).error((httpError)=> {
        if (httpError.status === 0 && !localUrl) {
          localFallback(identityProvider.destroySession, arguments, url, promiseRes, promiseErr)
        }
        else {
          let message = 'critical error destroying session on idp ' + httpError.status
          log(message)
          promiseErr(new Error(message))
        }
      })
    } catch (err) {
      if (err instanceof Error)
        throw err
      promiseErr(new Error('error attempting to destroy session at idp due to ' + err))
    }
  })
}

export default identityProvider


/** WEBPACK FOOTER **
 ** ./components/identity-provider/identity-provider.js
 **/